<template>
  <card>
    <table class="el-table">
      <tr>
        <th
          class="text-danger text-left"
          :style="headerCellStyle"
        >
          Category
        </th>
        <th
          class="text-danger text-center"
          :style="headerCellStyle"
        >
          Budget
        </th>
        <th
          class="text-danger text-center"
          :style="headerCellStyle"
        >
          Actual
        </th>
        <th
          class="text-danger text-center"
          :style="headerCellStyle"
        >
          Difference
        </th>
      </tr>
      <budget-summary-line
        summary-name="Registration"
        :summary-info="budgetInfo.RegistrationIncome"
        :cell-style="cellStyle"
        :header-cell-style="headerCellStyle"
      />
      <budget-summary-line
        summary-name="Other Income"
        :summary-info="budgetInfo.OtherIncome"
        :cell-style="cellStyle"
        :header-cell-style="headerCellStyle"
      />
      <tr>
        <td
          class="cell font-weight-bold"
          :style="cellStyle"
        >
          Total Income
        </td>
        <td
          class="cell text-center font-weight-bold"
          :style="cellStyle"
        >
          {{ formatAsCurrency(budgetInfo.Budget.BudgetedIncome) }}
        </td>
        <td
          class="cell text-center font-weight-bold"
          :style="cellStyle"
        >
          {{ formatAsCurrency(budgetInfo.Budget.ActualIncome) }}
        </td>
        <td
          class="cell text-center font-weight-bold"
          :class="{ 'text-red': budgetInfo.Budget.IncomeDifference < 0, 'text-green': budgetInfo.Budget.IncomeDifference > 0 }"
          :style="cellStyle"
        >
          {{ formatAsCurrency(budgetInfo.Budget.IncomeDifference) }}
        </td>
      </tr>
      <tr>
        <td />
        <td />
        <td />
        <td />
      </tr>
      <budget-summary-line
        summary-name="Scouter Expenses"
        :summary-info="budgetInfo.ScouterExpenses"
        :cell-style="cellStyle"
        :header-cell-style="headerCellStyle"
      />
      <budget-summary-line
        summary-name="Administrative Expenses"
        :summary-info="budgetInfo.AdminExpenses"
        :cell-style="cellStyle"
        :header-cell-style="headerCellStyle"
      />
      <budget-summary-line
        summary-name="Consumables"
        :summary-info="budgetInfo.Consumables"
        :cell-style="cellStyle"
        :header-cell-style="headerCellStyle"
      />
      <budget-summary-line
        summary-name="Food"
        :summary-info="budgetInfo.Food"
        :cell-style="cellStyle"
        :header-cell-style="headerCellStyle"
      />
      <budget-summary-line
        summary-name="Contingency Reserve"
        :summary-info="budgetInfo.Contingencies"
        :cell-style="cellStyle"
        :header-cell-style="headerCellStyle"
      />
      <budget-summary-line
        summary-name="Other Expenses"
        :summary-info="budgetInfo.OtherExpenses"
        :cell-style="cellStyle"
        :header-cell-style="headerCellStyle"
      />
      <tr>
        <td
          class="cell font-weight-bold"
          :style="cellStyle"
        >
          Total Expenses
        </td>
        <td
          class="cell text-center font-weight-bold"
          :style="cellStyle"
        >
          {{ formatAsCurrency(budgetInfo.Budget.BudgetedExpenses) }}
        </td>
        <td
          class="cell text-center font-weight-bold"
          :style="cellStyle"
        >
          {{ formatAsCurrency(budgetInfo.Budget.ActualExpenses) }}
        </td>
        <td
          class="cell text-center font-weight-bold"
          :class="{ 'text-red': budgetInfo.Budget.ExpenseDifference < 0, 'text-green': budgetInfo.Budget.ExpenseDifference > 0 }"
          :style="cellStyle"
        >
          {{ formatAsCurrency(budgetInfo.Budget.ExpenseDifference) }}
        </td>
      </tr>
      <tr>
        <td />
        <td />
        <td />
        <td />
      </tr>
      <tr>
        <td
          class="cell font-weight-bold"
          :style="cellStyle"
        >
          Net Totals
        </td>
        <td
          class="cell text-center font-weight-bold"
          :class="{ 'text-red': budgetInfo.Budget.BudgetProfit < 0 }"
          :style="cellStyle"
        >
          {{ formatAsCurrency(budgetInfo.Budget.BudgetProfit) }}
        </td>
        <td
          class="cell text-center font-weight-bold"
          :class="{ 'text-red': budgetInfo.Budget.ActualProfit < 0 }"
          :style="cellStyle"
        >
          {{ formatAsCurrency(budgetInfo.Budget.ActualProfit) }}
        </td>
        <td
          class="cell text-center font-weight-bold"
          :class="{ 'text-red': budgetInfo.Budget.ProfitDifference < 0, 'text-green': budgetInfo.Budget.ProfitDifference > 0 }"
          :style="cellStyle"
        >
          {{ formatAsCurrency(budgetInfo.Budget.ProfitDifference) }}
        </td>
      </tr>
    </table>
  </card>
</template>

<script>
import BudgetSummaryLine from '@/components/finance/budget-summary-line.vue'
import formatter from '@/services/formatter.js'

export default {
  name: 'BudgetSummary',
  components: {
    BudgetSummaryLine
  },
  props: {
    budgetInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    cellStyle: {
      type: Object,
      default: function () {
        return {}
      }
    },
    headerCellStyle: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    formatAsCurrency: function (value) {
      return formatter.formatAsCurrency(value)
    },
    formatAsPercent: function (value) {
      return formatter.formatAsPercent(value)
    }
  }
}
</script>
